import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Select from "react-select";
import Footer from './Footer.js';

function Add_Logistic_Form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();

    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [flashAlert1, setFlashAlert1] = useState(null);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [selectedDept, setSelectedDept] = useState('');
    const [Grade, setGrade] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const Loader = () => (
        <div className="loader-container1">
            <div className="spinner1"></div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        total_fuel_amt: 0,
        total_fuel_qty: 0,
        img: []
    });
    const handleBackClick = () => {
        navigate("/manage_fuel_forms");
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [transportRows, setTransportRows] = useState([
        {
            id: 1,
            dated: '',
            description: '',
            vehicle_number: '',
            vehicle_type: '',
            center: '',
            purpose: '',
            start_kms: '',
            start_time: '',
            end_kms: '',
            end_time: '',
            total_kms: '',
            center_from: '',
            center_to: '',
            fuel_quantity: 0,
            fuel_amount: 0,
            travel: '',
            department: '',
            repairs: '',
            remarks: '',
            bill_no: '',
            bill_amt: '',
            receipt: []
        }
    ]);

    useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [vehicleTypesRes, vehicleNumbersRes] = await Promise.all([
                    fetch(`${API_BASE_URL}getVehicleTypes`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_BASE_URL}getVehicleNumbers`, { headers: { Authorization: `Bearer ${token}` } })
                ]);

                if (!vehicleTypesRes.ok || !vehicleNumbersRes.ok) {
                    throw new Error('Failed to fetch data');
                }

                const vehicleTypesData = await vehicleTypesRes.json();
                const vehicleNumbersData = await vehicleNumbersRes.json();

                if (vehicleTypesData.status) setVehicleTypes(vehicleTypesData.data);
                if (vehicleNumbersData.status) setVehicleNumbers(vehicleNumbersData.data);
            } catch (error) {
                setError('Failed to fetch vehicle details');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 1 * 1024 * 1024;
        const MAX_WIDTH = 1024;
        const MAX_HEIGHT = 1024;
    
        let errorMessages = [];
        const validFiles = [];
    
        files.forEach(file => {
            if (file.type === "application/pdf") {
                // Accept PDFs directly if they are within size limit
                if (file.size > MAX_SIZE) {
                    toast.error(`PDF "${file.name}" exceeds the 1MB limit.`);
                } else {
                    validFiles.push(file);
                    processFiles(validFiles);
                }
            } else if (file.size > MAX_SIZE) {
                //errorMessages.push(`File "${file.name}" exceeds the 1MB limit. Resizing...`);
                resizeImage(file, MAX_WIDTH, MAX_HEIGHT, (resizedFile) => {
                    validFiles.push(resizedFile);
                    processFiles(validFiles);
                });
            } else {
                validFiles.push(file);
            }
        });
    
        if (validFiles.length === 0) return; // Stop if all files are invalid
    
        // Convert valid files to Base64
        processFiles(validFiles);
    };
    
    /**
     * Processes files by converting them to Base64
     */
    const processFiles = (files) => {
        const fileReaders = files.map(file => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        });
    
        Promise.all(fileReaders)
            .then(base64Files => {
                setFormData(prevData => ({
                    ...prevData,
                    img: base64Files
                }));
            })
            .catch(error => {
                console.error("Error reading files:", error);
            });
    };

    const handleTransportChange = (index, e) => {
        const { name, value, type, files } = e.target;
        setTransportRows(prevRows => {
            const updatedRows = [...prevRows];
    
            if (type === 'file' && files.length > 0) {
                const file = files[0];
                const MAX_SIZE = 1 * 1024 * 1024; // 1MB
    
                if (file.size > MAX_SIZE) {
                    //toast.warning(`File "${file.name}" exceeds 1MB limit. Resizing...`);
                    resizeImage(file, 1024, 1024, (resizedFile) => {
                        updatedRows[index][name] = resizedFile;
                        setTransportRows(updatedRows);
                    });
                    return updatedRows;
                }
    
                updatedRows[index][name] = file;
            } else {
                updatedRows[index][name] = value;
            }
    
            setTimeout(() => {
                const startKm = parseFloat(updatedRows[index].start_kms);
                const endKm = parseFloat(updatedRows[index].end_kms);
    
                if (!isNaN(startKm) && !isNaN(endKm)) {
                    if (endKm <= startKm) {
                        toast.error("End KMs must be greater than Start KMs.");
                    } else {
                        updatedRows[index].total_kms = endKm - startKm;
                    }
                }
            }, 900);
    
            if (name === 'vehicle_number') {
                if (!vehicleNumbers || vehicleNumbers.length === 0) {
                    console.error("Vehicle Numbers not loaded yet.");
                    return updatedRows;
                }
    
                const vehicle = vehicleNumbers.find(v => v.vehicle_number === value);
                if (vehicle) {
                    updatedRows[index].vehicle_type = vehicle.vehicle_type || '';
                    updatedRows[index].description = vehicle.description || '';
                } else {
                    updatedRows[index].vehicle_type = '';
                    updatedRows[index].description = '';
                }
    
                updatedRows[index].fuel_quantity = 0;
            }
    
            if (name === "dept_name") {
                updatedRows[index].dept_name = value;
            }
    
            return updatedRows;
        });
    };
    
    /**
     * Resizes an image if it exceeds the max allowed dimensions.
     */
    const resizeImage = (file, maxWidth, maxHeight, callback) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                let width = img.width;
                let height = img.height;
    
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
    
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);
    
                canvas.toBlob((blob) => {
                    const resizedFile = new File([blob], file.name, {
                        type: file.type,
                        lastModified: Date.now(),
                    });
                    callback(resizedFile);
                }, file.type);
            };
        };
    };
    useEffect(() => {
        const fetchDepartments = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}departments`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Departments data:", result); // Debugging log

                if (Array.isArray(result)) {
                    setDepartments(result);
                } else {
                    throw new Error("Invalid response format");
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to load departments.');
            } finally {
                setLoading(false);
            }
        };

        fetchDepartments();
    }, []);

    useEffect(() => {
        const fetchLocations = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}locations`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Locations data:", result); // Debugging log

                if (Array.isArray(result)) {
                    setLocations(result);
                } else {
                    throw new Error("Invalid response format");
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to load locations.');
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, []);

    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Profile data:", result); // Log to check fetched data

                if (result.status) {
                    const { profile } = result;

                    // Set default values from profile
                    setEmpCode(profile.emp_code || '');
                    setGrade(profile.grade || '');
                    setFormData(prevData => ({
                        ...prevData,
                        comp_name: profile.comp_name || '',
                        emp_code: profile.emp_code || '',
                        dept_name: profile.dept_name || '',
                        designation_name: profile.designation_name || '',
                        grade: profile.grade || '',
                        report_mngr: profile.report_mngr || '',
                        mobile: profile.mobile || '', // Do not display the password
                        bank_acnum: profile.bank_acnum || '',
                        bank_name: profile.bank_name || '',
                        ifsc_code: profile.ifsc_code || '',
                        location_name: profile.location_name || '',
                    }));
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    const handleAddTransportRow = () => {
        setTransportRows(prevRows => [
            ...prevRows,
            {
                id: prevRows.length + 1,
                dated: '',
                description: '',
                vehicle_number: '',
                vehicle_type: '',
                center: '',
                purpose: '',
                start_kms: '',
                start_time: '',
                end_kms: '',
                end_time: '',
                total_kms: '',
                center_from: '',
                center_to: '',
                fuel_quantity: 0,
                fuel_amount: 0,
                travel: '',
                department: '',
                repairs: '',
                remarks: '',
                bill_no: '',
                bill_amt: '',
                receipt: []
            }
        ]);
    };

    const handleRemoveTransportRow = (index) => {
        if (transportRows.length > 1) {
            setTransportRows(prevRows => prevRows.filter((_, i) => i !== index));
        }
    };

    const calculateTotals = () => {
        let total_amt = 0;
        let total_qty = 0;

        transportRows.forEach(row => {
            total_amt += parseFloat(row.fuel_amount) || 0;
            total_qty += parseFloat(row.fuel_quantity) || 0;
        });

        setFormData(prevState => ({
            ...prevState,
            total_fuel_amt: total_amt,
            total_fuel_qty: total_qty
        }));
    };



    useEffect(() => {
        calculateTotals();
    }, [transportRows]);
    const handleSubmit = async (e) => {
        e.preventDefault();

        for (let row of transportRows) {
            const startKm = parseFloat(row.start_kms);
            const endKm = parseFloat(row.end_kms);
    
            if (isNaN(startKm) || isNaN(endKm)) {
                toast.error("Please enter both Start and End KMs.");
                return; // Stop submission
            }
    
            if (endKm <= startKm) {
                toast.error("End KMs must be greater than Start KMs.");
                return; // Stop submission
            }
        }

        if (!isSubmitAllowed) {
            toast.error("Please fix the file size errors before submitting.");
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                toast.error("Authentication token is missing. Please log in again.");
                setIsSubmitting(false);
                return;
            }

            // Convert a file to Base64
            const convertToBase64 = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result); // Keep full Base64 string
                    reader.onerror = (error) => reject(error);
                });
            };

            // Convert images to Base64
            const imgBase64Array = await Promise.all(
                formData.img.map(async (file) =>
                    file instanceof File ? await convertToBase64(file) : file
                )
            );

            // Convert transport row receipts to Base64
            const transportRowsWithBase64 = await Promise.all(
                transportRows.map(async (row) => ({
                    ...row,
                    receipt: row.receipt instanceof File ? await convertToBase64(row.receipt) : row.receipt
                }))
            );

            // Construct JSON payload
            const payload = {
                comp_name: formData.comp_name,
                emp_code: formData.emp_code,
                grade: formData.grade,
                dept_name: formData.dept_name,
                designation_name: formData.designation_name,
                report_mngr: formData.report_mngr,
                mode_of_travel: formData.mode_of_travel,
                to_city: formData.to_city,
                guesthouse: formData.guesthouse,
                bank_acnum: formData.bank_acnum,
                mobile: formData.mobile,
                location_name: formData.location_name,
                bank_name: formData.bank_name,
                ifsc_code: formData.ifsc_code,
                transportRows: transportRowsWithBase64,
                img: imgBase64Array,
                sum_km: transportRows.reduce((sum, row) => sum + (row.end_kms - row.start_kms || 0), 0),
                start_km: transportRows.reduce((sum, row) => sum + (row.start_kms || 0), 0),
                end_km: transportRows.reduce((sum, row) => sum + (row.end_kms || 0), 0),
                sum_repairs: transportRows.reduce((sum, row) => sum + (row.repairs || 0), 0),
                sum_bill: transportRows.reduce((sum, row) => sum + (row.bill_amt || 0), 0)

            };

            const response = await fetch(`${API_BASE_URL}addLogisticForm`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (response.ok && result.status) {
                toast.success("Fuel Form submitted successfully!");
                setTimeout(() => {
                    navigate(`/edit_logistic_form/${result.id}`);
                }, 2000);
            } else {
                toast.error(result.message || "An error occurred while submitting the form.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            toast.error("Failed to submit form. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const hasAmbulance = transportRows.some(row => row.purpose === "patient");


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Add New Logistic Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Fuel Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData.emp_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="location_name"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Logistic Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">
                                                    <button type="button" onClick={handleAddTransportRow} className="btn btn-sm btn-primary">+</button>

                                                    {/* Outer Wrapper for Scroll */}
                                                    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                                                        {/* Table Container with Scrolling */}

                                                        <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto", whiteSpace: "nowrap" }}>
                                                            <table className="table table-bordered" style={{ minWidth: "2000px", tableLayout: "fixed", display: "block" }}>
                                                                <thead>
                                                                    <tr>
                                                                        <td colSpan="12"></td>
                                                                    </tr>
                                                                    <tr className="header-row text-center">
                                                                        <th>Date<span className="text-danger">*</span></th>

                                                                        <th>Vehicle Number<span className="text-danger">*</span></th>
                                                                        <th>Type</th>
                                                                        <th>Description</th>
                                                                        <th>Branch<span className="text-danger">*</span></th>
                                                                        <th>Purpose<span className="text-danger">*</span></th>
                                                                        <th>Start KMs<span className="text-danger">*</span></th>
                                                                        <th>Start Time<span className="text-danger">*</span></th>
                                                                        <th>End KMs<span className="text-danger">*</span></th>
                                                                        <th>End Time<span className="text-danger">*</span></th>
                                                                        <th>Total KMs</th>
                                                                        <th>From</th>
                                                                        <th>To</th>

                                                                        <th>Travel</th>
                                                                        <th>Department</th>
                                                                        <th>Requested By</th>
                                                                        {/* <th>Repairs</th> */}
                                                                        <th>Remarks</th>
                                                                        {hasAmbulance && (
                                                                            <>
                                                                                <th>Bill No</th>
                                                                                <th>Bill Amt</th>
                                                                                <th>Bills Images</th>
                                                                            </>
                                                                        )}
                                                                        
                                                                        <th>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {transportRows.map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input type="date" name="dated" value={row.dated} onChange={(e) => handleTransportChange(index, e)}
                                                                                    className="form-control input-font" max={new Date().toISOString().split("T")[0]} required={index === 0} />
                                                                            </td>

                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input placeholder='Number' list="vm" className='form-control input-font' name='vehicle_number'
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                                <datalist id="vm">
                                                                                    {vehicleNumbers.map((vehicleNumber) => (
                                                                                        <option key={vehicleNumber.id} value={vehicleNumber.vehicle_number}>
                                                                                            {vehicleNumber.vehicle_number}
                                                                                        </option>
                                                                                    ))}
                                                                                </datalist>
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" readOnly value={row.vehicle_type} name="vehicle_type" />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <select
                                                                                    name="description"
                                                                                    value={row.description || ''}
                                                                                    className="form-control input-font"
                                                                                    onChange={(e) => handleTransportChange(index, e)}
                                                                                    disabled
                                                                                >
                                                                                    <option value="">Select Booked By</option>
                                                                                    <option value="Four Wheeler">Four Wheeler</option>
                                                                                    <option value="Three Wheeler">Three Wheeler</option>
                                                                                    <option value="Two Wheeler">Two Wheeler</option>
                                                                                </select>
                                                                            </td>
                                                                            {/* <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" value={row.center} name="center"
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td> */}
                                                                            <td style={{ minWidth: '15rem' }}>
                                                                                <Select
                                                                                required={index === 0}
                                                                                    name="center"
                                                                                    value={locations.find(location => location.location_name === row.center)
                                                                                        ? { value: row.center, label: row.center }
                                                                                        : null}
                                                                                    onChange={(selectedOption) =>
                                                                                        handleTransportChange(index, { target: { name: "center", value: selectedOption?.value } })
                                                                                    }
                                                                                    options={locations.map(location => ({ value: location.location_name, label: location.location_name }))}
                                                                                    className="form-control input-font"
                                                                                    isSearchable={true}
                                                                                    placeholder="Select Location"
                                                                                    menuPortalTarget={document.body} // Prevents dropdown cutoff
                                                                                    styles={{
                                                                                        control: (provided) => ({
                                                                                            ...provided,
                                                                                            minHeight: '20px', // Reduced height
                                                                                            height: '20px', // Set exact height
                                                                                            borderRadius: '4px',
                                                                                            borderColor: '#ced4da',
                                                                                            fontSize: '13px', // Reduce font size slightly
                                                                                            padding: '0px 5px', // Reduce padding
                                                                                        }),
                                                                                        dropdownIndicator: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '2px', // Reduce dropdown arrow padding
                                                                                        }),
                                                                                        clearIndicator: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '2px', // Reduce clear button padding
                                                                                        }),
                                                                                        menu: (provided) => ({
                                                                                            ...provided,
                                                                                            zIndex: 9999, // Ensures dropdown is visible
                                                                                        }),
                                                                                        input: (provided) => ({
                                                                                            ...provided,
                                                                                            fontSize: '13px', // Reduce input font size
                                                                                            padding: '0px', // Remove extra padding inside input
                                                                                        }),
                                                                                        valueContainer: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '0px 6px', // Reduce spacing around selected value
                                                                                        }),
                                                                                    }}
                                                                                />
                                                                            </td>   
                                                                            <td style={{ minWidth: '12rem' }}>
                                                                                
                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.purpose}
                                                                                name="purpose"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                required={index === 0}
                                                                            >
                                                                                <option value="">Select Purpose</option>
                                                                                <option value="office_purpose">Office Purpose</option>
                                                                                <option value="branch_visit">Branch Visit</option>
                                                                                <option value="patient">Patient</option>
                                                                                <option value="other_purpose">Other Purpose</option>

                                                                            </select>
                                                                            
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="number" value={row.start_kms} name="start_kms"
                                                                                required={index === 0}
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="time" value={row.start_time} name="start_time"
                                                                                required={index === 0}
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="number" value={row.end_kms} name="end_kms"
                                                                                required={index === 0}
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="time" value={row.end_time} name="end_time"
                                                                                required={index === 0}
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input
                                                                                    className="form-control input-font"
                                                                                    type="number"
                                                                                    value={row.end_kms - row.start_kms || 0} // Automatically calculates total_kms
                                                                                    name="total_kms"
                                                                                    readOnly // Makes it non-editable
                                                                                />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" value={row.center_from} name="center_from"
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" value={row.center_to} name="center_to"
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>

                                                                            <td style={{ minWidth: '6rem' }}>
                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.travel}
                                                                                name="travel"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                            >
                                                                                <option value="">Select Station</option>
                                                                                <option value="Ex_Station">Ex Station</option>
                                                                                <option value="Out_Station">Out Station</option>
                                                                                <option value="Local">Local</option>
                                                                            </select>
                                                                            </td>
                                                                            <td style={{ minWidth: '15rem' }}>
                                                                                <Select
                                                                                    name="department"
                                                                                    value={departments.find(dept => dept.dept_name === row.department)
                                                                                        ? { value: row.department, label: row.department }
                                                                                        : null}
                                                                                    onChange={(selectedOption) =>
                                                                                        handleTransportChange(index, { target: { name: "department", value: selectedOption?.value } })
                                                                                    }
                                                                                    options={departments.map(dept => ({ value: dept.dept_name, label: dept.dept_name }))}
                                                                                    className="form-control input-font"
                                                                                    isSearchable={true}
                                                                                    placeholder="Select Department"
                                                                                    menuPortalTarget={document.body} // Prevents dropdown cutoff
                                                                                    styles={{
                                                                                        control: (provided) => ({
                                                                                            ...provided,
                                                                                            minHeight: '20px', // Reduced height
                                                                                            height: '20px', // Set exact height
                                                                                            borderRadius: '4px',
                                                                                            borderColor: '#ced4da',
                                                                                            fontSize: '13px', // Reduce font size slightly
                                                                                            padding: '0px 5px', // Reduce padding
                                                                                        }),
                                                                                        dropdownIndicator: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '2px', // Reduce dropdown arrow padding
                                                                                        }),
                                                                                        clearIndicator: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '2px', // Reduce clear button padding
                                                                                        }),
                                                                                        menu: (provided) => ({
                                                                                            ...provided,
                                                                                            zIndex: 9999, // Ensures dropdown is visible
                                                                                        }),
                                                                                        input: (provided) => ({
                                                                                            ...provided,
                                                                                            fontSize: '13px', // Reduce input font size
                                                                                            padding: '0px', // Remove extra padding inside input
                                                                                        }),
                                                                                        valueContainer: (provided) => ({
                                                                                            ...provided,
                                                                                            padding: '0px 6px', // Reduce spacing around selected value
                                                                                        }),
                                                                                    }}
                                                                                />
                                                                            </td>                                                               <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" value={row.requested_by} name="requested_by"
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" value={row.remarks} name="remarks"
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td>
                                                                            {/* <td style={{ minWidth: '6rem' }}>
                                                                                <input className="form-control input-font" type="text" value={row.remarks} name="remarks"
                                                                                    onChange={(e) => handleTransportChange(index, e)} />
                                                                            </td> */}
                                                                            {row.purpose === "patient" && (
                                                                                <>
                                                                                    <td style={{ minWidth: '6rem' }}>
                                                                                        <input
                                                                                            className="form-control input-font"
                                                                                            type="text"
                                                                                            value={row.bill_no}
                                                                                            name="bill_no"
                                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                                            required={index === 0}
                                                                                        />
                                                                                    </td>
                                                                                    <td style={{ minWidth: '6rem' }}>
                                                                                        <input
                                                                                            className="form-control input-font"
                                                                                            type="text"
                                                                                            value={row.bill_amt}
                                                                                            name="bill_amt"
                                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                                            required={index === 0}
                                                                                        />
                                                                                    </td>
                                                                                    <td style={{ minWidth: '12rem' }}>
                                                                                <input type="file" name="receipt" accept=".jpg,.jpeg,.png,.pdf" required={index === 0}
                                                                                    onChange={(e) => handleTransportChange(index, e)} className="form-control input-font" />
                                                                            </td>
                                                                                </>
                                                                            )}
                                                                            
                                                                            <td>
                                                                                <button type="button" onClick={() => handleRemoveTransportRow(index)}
                                                                                    className="btn btn-sm btn-danger">×</button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        {/* Sum of Total KMs under Total KMs column */}
                                                                       
                                                                        <td colSpan="6"></td> {/* Empty columns before Total KMs */}
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + (row.start_kms || 0), 0)}</b></td>
                                                                        <td colSpan="0"></td>
                                                                        
                                                                         {/* Empty columns before Total KMs */}
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + (row.end_kms || 0), 0)}</b></td>
                                                                        <td><b>Sum of Total KMs:</b></td>
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + (row.end_kms - row.start_kms || 0), 0)}</b></td>

                                                                        {/* Empty columns until Repairs */}
                                                                        <td colSpan="5"></td>

                                                                        {/* Total Repairs Cost under Repairs column */}
                                                                        {/* <td><b>Total Repairs Cost:</b></td>
                                                                        <td><b>{transportRows.reduce((sum, row) => sum + (parseFloat(row.repairs) || 0), 0)}</b></td> */}

                                                                        {/* Empty columns until Bill Amount */}
                                                                        <td colSpan="1"></td>

                                                                        {/* Total Bill Amount under Bill Amt column */}
                                                                        {hasAmbulance && (
                                                                            <>
                                                                                <td><b>Total Bill Amount:</b></td>
                                                                                <td><b>{transportRows.reduce((sum, row) => sum + (parseFloat(row.bill_amt) || 0), 0)}</b></td>
                                                                            </>
                                                                        )}

                                                                        {/* Empty remaining columns */}
                                                                        <td colSpan="1"></td>
                                                                    </tr>
                                                                </tfoot>

                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>


                                            </fieldset>


                                            {/* Upload Images Section */}
                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <input
                                                    type="file"
                                                    name="img"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={handleFileChange}
                                                    className="form-control mb-3"
                                                />

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center">
                                                    <button type="submit" className="btn btn-success">
                                                        {isSubmitting ? 'Creating New...' : 'Save'}
                                                    </button>
                                                    <button type="button" className="btn btn-secondary ml-3" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </section>

                                        </form>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Add_Logistic_Form